module.exports = __webpack_public_path__ + "img/error.1ece9fd1.svg";